






















































import { computed, defineComponent, PropType } from '@nuxtjs/composition-api';
import useUnitConversion from '@shared/composables/useUnitConversion';
import { ISBSizeGuideTable } from '@shared/types/ISBSizeGuide';

interface Props {
  table: ISBSizeGuideTable;
}

export default defineComponent({
  name: 'SizeGuideTable',
  props: {
    table: {
      type: Object as PropType<ISBSizeGuideTable>,
      required: true,
    },
  },
  setup({ table }: Props) {
    const { listUnits, units, toUnits, setUnits, convertUnits } = useUnitConversion();

    const title = computed(() => table?.title);
    const guide = computed(() => table?.guide);
    const thead = computed(() => table?.guide?.thead ?? []);
    const tbody = computed(() => table?.guide?.tbody ?? []);
    const guideUnits = computed(() => table?.guide_units);

    const colLabels = thead.value.map((th) => th.value);

    const formatColLabel = (label: string) =>
      label.replace(/( ?\(?cms?\)?| ?\(?inche?s?\)?)/gi, '');

    const canConvertTable = computed(() => colLabels.some(toUnits) || toUnits(guideUnits.value));

    const convertCell = (value: string, colIndex: number) => {
      // If any columns have 'cm', 'inch', 'inches' then only convert those columns
      if (colLabels.some(toUnits) && !toUnits(colLabels[colIndex])) {
        return value;
      }
      const unitsFrom = toUnits(colLabels[colIndex]) ?? toUnits(guideUnits.value);

      return convertUnits(value, unitsFrom);
    };

    const colWidthPercent = computed(() => 100 / thead.value.length);

    return {
      title,
      guide,
      thead,
      tbody,
      units,
      colWidthPercent,
      listUnits,
      convertCell,
      formatColLabel,
      canConvertTable,
      setUnits,
    };
  },
});
